import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { House, ChevronRight } from 'lucide-react';
import './Breadcrumb.scss';

const Breadcrumb = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  const pathMap = {
    about: '회사소개',
    greeting: '인사말',
    map: '찾아오시는 길',
    intro: '회사소개서',
    production: '생산',
    facilities: '보유설비',
    process: '제조공정',
    products: '제품소개',
    'double-sided': '양면테이프',
    industrial: '산업용 테이프',
    foam: '폼테이프',
    community: '커뮤니티',
    notice: '공지사항',
    cert: '인증서 및 성적서',
    'request-sample': '샘플요청',
    'request-quote': '견적요청',
    whaja: '화지양면 테이프',
    hotmelt: '핫멜트양면 테이프',
    pet90: 'PET90 양면 테이프',
    kraft: '크라프트양면 테이프',
    crown: '인쇄양면 테이프',
    masking: '마스킹테이프',
    line: '라인 테이프',
    eva: 'EVA폼 테이프',
    pe: 'PE폼 테이프',
    orders: '발주관리',
  };

  return (
    <nav className="breadcrumb" aria-label="breadcrumb">
      <div className="container">
        <ul className="breadcrumb-list">
          <li className="home">
            <Link to="/" aria-label="홈으로 이동">
              <House size={16} strokeWidth={2.2} />
            </Link>
          </li>

          {pathnames.map((name, index) => {
            const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
            const isLast = index === pathnames.length - 1;
            const displayName = pathMap[name] || name;

            return (
              <li key={`${name}-${index}`} className={isLast ? 'active' : ''}>
                <span className="separator" aria-hidden="true">
                  <ChevronRight size={15} />
                </span>

                {isLast ? <span className="current">{displayName}</span> : <Link to={routeTo}>{displayName}</Link>}
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
};

export default Breadcrumb;
